import { render, staticRenderFns } from "./ManageCard.vue?vue&type=template&id=5064165a&scoped=true"
import script from "./ManageCard.vue?vue&type=script&lang=js"
export * from "./ManageCard.vue?vue&type=script&lang=js"
import style0 from "./ManageCard.vue?vue&type=style&index=0&id=5064165a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064165a",
  null
  
)

export default component.exports